/**
 * Firestore collection path constants
 * Matches the iOS app's Firestore structure
 */

export const COLLECTIONS = {
  OSCARS_PARTIES: 'oscars_parties',
  CATEGORIES: 'categories',
  BALLOTS: 'ballots',
  BONUS_QUESTIONS: 'bonus_questions',
  PAST_WINNERS: 'past_winners'
};

/**
 * Get the path to a party's subcollection
 * @param {string} partyId - The party document ID
 * @param {string} subcollection - The subcollection name
 * @returns {string} The full path to the subcollection
 */
export const getSubcollectionPath = (partyId, subcollection) => {
  return `${COLLECTIONS.OSCARS_PARTIES}/${partyId}/${subcollection}`;
};

/**
 * Get the path to categories for a party
 * @param {string} partyId - The party document ID
 * @returns {string} The full path to categories
 */
export const getCategoriesPath = (partyId) => {
  return getSubcollectionPath(partyId, COLLECTIONS.CATEGORIES);
};

/**
 * Get the path to ballots for a party
 * @param {string} partyId - The party document ID
 * @returns {string} The full path to ballots
 */
export const getBallotsPath = (partyId) => {
  return getSubcollectionPath(partyId, COLLECTIONS.BALLOTS);
};

/**
 * Get the path to bonus questions for a party
 * @param {string} partyId - The party document ID
 * @returns {string} The full path to bonus questions
 */
export const getBonusQuestionsPath = (partyId) => {
  return getSubcollectionPath(partyId, COLLECTIONS.BONUS_QUESTIONS);
};

/**
 * Get the path to past winners for a party
 * @param {string} partyId - The party document ID
 * @returns {string} The full path to past winners
 */
export const getPastWinnersPath = () => {
  return COLLECTIONS.PAST_WINNERS;
};